import * as React from "react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Select from "react-select";
import "./templateTabs.css";
import BalanceSheet from "./BalanceSheet";
import PnlStatement from "./PnlStatement";
import Pattern2 from "./Pattern2";
// import { filterOptionsData } from "../../Console/Component/services/mockHandler";
import { useSelector, useDispatch } from "react-redux";

import { getMappingDataApiHandler } from "../../services/api/apiHandler";
import swal from "sweetalert";

import buttoncss from "../../myfin_v2/css/button.module.css";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosuretbcss from "../../myfin_v2/css/bookclosuretb.module.css";
import FSfilterDropdown from "../../myfin_v2/elements/FSfilterDropdown";


const shortcut = {
  color: "var(--clr-accent)",
  fontWeight: "600",
  fontSize: "1rem",
  marginLeft: "1rem",
  cursor: "pointer",
  borderRadius: "50%",
  border: "2px solid var(--clr-accent)",
  width: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const TemplateTabs = (props) => {
  // const {checkYearly, selectedRow} = useSelector((state)=> state.selectedDragReducer);
  const { setAddNoteGrp } = props;
  const [group, setGroup] = useState();
  const [rows, setRows] = useState([]);
  const [hideData, setHideData] = useState([]);
  const [hideChildData, sethideChildData] = useState([]);

  const [bsData, setBSData] = useState(null);
  const [plData, setPLData] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [selFilterData, setSelFilterData] = useState({});
  const [notes, setNotes] = useState([]);

  const [selectedL1, setSelectedL1] = useState(null);
  const [selectedL2, setSelectedL2] = useState(null);

  const dispatch = useDispatch()

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const [value, setValue] = useState(0);
  const R_tb_id = useSelector((initialState) => initialState.reducer.tb_id);
  const LOCAL_tb_id = localStorage.getItem("tb_id");
  const project_id = localStorage.getItem("project_id");
  let tb_id = R_tb_id ? R_tb_id : LOCAL_tb_id;

  const [isHide, setHide] = useState(false);

  useEffect(() => {
    (async () => {

      await getMappingData();
    })()
  }, [])




  useEffect(() => {
    setRows([]);
    setHide(false);

  }, [value, props.updateTabs]);

  function handleSelect(e) {
    console.log("e", e);
    if (e == null) {
      return;
    }
    if (value === 0) {
      // main object
      const mainId = e.value[0];
      const subGroupId = e.value[1];
      const l1Data = bsData.find(item => item._id === mainId);

      // subgroup object (first match by _id)
      const l2Data = l1Data?.subgroup.find(
        sg => sg._id === subGroupId
      );
      setSelFilterData(e);
      setSelectedL1(l1Data);
      setSelectedL2(l2Data);
    }
    if (value === 1) {
      // main object
      const mainId = e.value[0];
      const subGroupId = e.value[1];
      const l1Data = plData.find(item => item._id === mainId);

      // subgroup object (first match by _id)
      const l2Data = l1Data?.subgroup.find(
        sg => sg._id === subGroupId
      );
      setSelFilterData(e);
      setSelectedL1(l1Data);
      setSelectedL2(l2Data);
    }

  }

  useEffect(() => {
    // setRows([])
    if (hideData.length > 0) {
      hideData.map((hidedata) => {
        delete rows[hidedata];
      });


    } else {
    }
  }, [isHide]);

  const handleEye = () => {
    if (isHide) {
      setHide(false);
      // fetchBalanceSheet();
    } else {
      setHide(true);
    }
  };

  const handleOptions = (o) => {
    setRows([]);
    if (o === 0) {
      setValue(0);
    } else {
      setValue(1);
    }
  };


  useEffect(() => {
    setFilterData([]);
    setSelectedL1(null);
    setSelectedL2(null);
    setSelFilterData({ label: "", value: "" });
    if ((value === 0) && bsData) {
      const bsL2Options = bsData.flatMap(main =>
        main.subgroup.map(sub => ({
          label: sub.name,
          value: [main._id, sub._id]
        }))
      );

      setFilterData(bsL2Options)
    }
    if ((value === 1) && plData) {
      console.log("plData", plData);
      const plL2Options = plData.flatMap(main =>
        main.subgroup.map(sub => ({
          label: sub.name,
          value: [main._id, sub._id]
        }))
      );
      setFilterData(plL2Options)
    }
  }, [value, bsData, plData])


  const getMappingData = () => {
    const getParams = {
      projectID: project_id,
    };
    getMappingDataApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const respData = response?.data;
          setBSData(respData.grouping.filter(item => item.category === "BS"))
          setPLData(respData.grouping.filter(item => item.category === "PL"))
        } else {
          swal(
            "Error",
            "Unable in getting mapping data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          "Unable in getting mapping data",
          "error"
        );
      });
  };

  return (
    <div style={{ width: "100%" }}>
      <div className={`${bookclosuretbcss.tempNotesSection}  px-2 mb-1`}>
        <FSfilterDropdown
          class_={commoncss.w70pct}
          class2_={buttoncss.greyBg2}
          options={filterData}
          selected={selFilterData}
          onSelect={(e) => {
            handleSelect(e);
          }}
          placeHolder={"Notes"}
        />

        <div className="button-group" style={{ "align-content": "center" }}>
          <button
            className={`${buttoncss.custom_btn} ${value === 0 ? buttoncss.primary : buttoncss.secondary
              }`}
            style={{
              "border-radius": "8.18px 0px 0px 8.18px",
              padding: "5px 7px",
              "min-width": "68px",

              ...(value === 1 && { background: "#f5f5f5" }),
            }}
            onClick={(e) => {
              handleOptions(0);
              // setValue(0);
            }}
          >
            BS
          </button>
          <button
            className={`${buttoncss.custom_btn} ${value === 1 ? buttoncss.primary : buttoncss.secondary
              }`}
            style={{
              "border-radius": "0 8.18px 8.18px 0",
              "padding": "5px 7px",
              "min-width": "68px",
              ...(value !== 1 && { background: "#f5f5f5" }),
            }}
            onClick={(e) => {
              handleOptions(1);
              // setValue(1);
            }}
          >
            P&L
          </button>
        </div>
      </div>
      <Box className="MuiBox-rootTab  px-2" sx={{ width: "100%" }}>
        <TabPanel value={value} index={0}>
          <BalanceSheet
            setTempValue={setValue}
            setGroup={setGroup}
            // projectData={projectData}
            setHideData={setHideData}
            hideData={hideData}
            hideChildData={hideChildData}
            setAddNoteGrp={setAddNoteGrp}
            bsData={bsData}
            selectedL1 = {selectedL1}
            selectedL2 = {selectedL2}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PnlStatement
            setTempValue={setValue}
            // projectData={projectData}
            setHideData={setHideData}
            hideData={hideData}
            hideChildData={hideChildData}
            setAddNoteGrp={setAddNoteGrp}
            plData={plData}
            selectedL1 = {selectedL1}
            selectedL2 = {selectedL2}
          />
        </TabPanel>
      </Box>
    </div>
  );
};

export default TemplateTabs;
